import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	Modal, ModalHeader, ModalBody, FormGroup, FormText, Label, Input, Button, Form, UncontrolledTooltip as Tooltip
} from 'reactstrap';

import { getData, updateData } from 'core/ducks/update';
import { Table, Tbody, Tr, Td } from 'css-table';

class AssignModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			reviewers: {},
			pending: true,
			reviewer: props.data.reviewer_uuid,
			submitResponse: {},
			isFormSubmitted: false,
		};
	}

	componentDidMount() {
		this.props.dispatch(getData('users/limit/100/sort/lastname/sort_method/asc/fq/role:reviewer;active:true'))
			.then(reviewers => this.setState({reviewers, pending: false}))
			.catch(err => {
				this.setState({pending: false});
				console.warn(err);
				this.props.cancel();
			});
	}

	handleChange = (event) => {
		const { checked, value } = event.target;
		if (checked)
			this.setState({
				reviewer: value,
			})
	}

	handleSubmit = (event) => {
		event.preventDefault();
		const { dispatch, data } = this.props;
		const { reviewer } = this.state;
		dispatch(
			updateData('flows/application/bulk/assign', { reviewer, applications: data })
		).then(submitResponse => this.setState({submitResponse, isFormSubmitted: true}));
	}

	render() {

		const { isOpen, cancel, data } = this.props;
		const { reviewers, pending, isFormSubmitted } = this.state;

		if (pending)
			return null;

		return (
			<Modal isOpen={isOpen}>
				<ModalHeader toggle={cancel}>
					Ανάθεση <i className="fa fa-question-circle mx-2" id="assign-info"></i>
					<Tooltip target="assign-info" placement="auto" autohide={false}>
						<div className="text-justify">Λαμβάνονται υπόψη μόνο όσες από τις επιλεγμένες αιτήσεις βρίσκονται σε κατάλληλη κατάσταση.</div>
						<div className="mt-2 text-left font-weight-bold">
							Ανάθεση σε χειριστή
							<ul>
								<li><em>Παραδεκτή υπό αξιολόγηση</em></li>
							</ul>
						</div>
						<div className="text-left font-weight-bold">
							Εκ νέου ανάθεση
							<ul>
								<li><em>Σε αξιολόγηση χειριστή</em></li>
								<li><em>Σε αξιολόγηση προϊσταμένου</em></li>
								<li><em>Προεγκρίθηκε</em></li>
								<li><em>Απορρίφθηκε</em></li>
							</ul>
						</div>
						</Tooltip>
				</ModalHeader>
				<ModalBody>
					<Form onSubmit={this.handleSubmit}>
						<FormText className="text-right"><b>Επιλογή</b>: {data.length} αιτήσεις</FormText>
						{Object.entries(reviewers.values).map(([uuid, reviewer]) => (
							<FormGroup key={`reviewer_${uuid}`} disabled={isFormSubmitted} check >
								<Label check >
									<Input disabled={isFormSubmitted} type="radio" checked={this.state.reviewer === uuid} value={uuid} onChange={this.handleChange} />{' '}
									{`${reviewer.lastname} ${reviewer.firstname}`}
								</Label>
							</FormGroup>
						))}
						{!isFormSubmitted &&
							<div className="d-flex justify-content-end">
								<Button type="submit" color="warning" disabled={!this.state.reviewer || isFormSubmitted}>Ανάθεση</Button>
							</div>
						}
					</Form>
					{isFormSubmitted &&
						<>
							<Table className="mt-4 border-top border-primary">
								<Tbody>
									<Tr>
										<Td>Ανατέθηκαν</Td>
										<Td>{this.state.submitResponse.assigned}</Td>
									</Tr>
									<Tr>
										<Td>Ανατέθηκαν εκ νέου</Td>
										<Td>{this.state.submitResponse.reassigned}</Td>
									</Tr>
								</Tbody>
							</Table>
							<div className="d-flex justify-content-end">
								<Button color="success" onClick={this.props.toggle}>Ολοκλήρωση</Button>
							</div>
						</>
					}
				</ModalBody>
			</Modal>
		);
	}
}

AssignModal = connect(null)(AssignModal);

export default AssignModal;
